<div class="top-bar">
    <div class="app-notif-and-account">
        <app-notif-and-account></app-notif-and-account>
    </div>
</div>